import ButtonsContainer from "../general/ButtonsContainer";
import { Button } from "@yoast/ui-library";
import { defineMessages, FormattedMessage } from "react-intl";
import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/react/20/solid";
import * as styles from "./InstallStyles.module.scss";
import { SkipInstallationFlowLink } from "./SkipInstallationFlowLink";
import React, { useContext } from "react";
import { InstallContext, Steps } from "./InstallContext";


const messages = defineMessages( {
	continueButton: {
		id: "install.button.continue",
		defaultMessage: "Continue",
	},
	BrandInsightsContinueButton: {
		id: "install.button.brandInsightsContinue",
		defaultMessage: "Continue setting up your products",
	},
	back: {
		id: "install.button.back",
		defaultMessage: "Back",
	},
} );

export const StepNavigation = () => {
	const { steps, goToNextStep, goToPreviousStep } = useContext( InstallContext );

	const isBrandInsightsStep = steps.current.id === Steps.BRAND_INSIGHTS.id;
	const otherProductsToSetUp = steps.available.some( step => step.id === Steps.CONNECT_YOUR_SITE.id );

	return <>
		<ButtonsContainer className={ styles.buttonContainer }>
			{ steps.canGoBack && <Button variant={ "tertiary" } onClick={ goToPreviousStep } data-testid={ "previous-step-button" }>
				<ArrowLongLeftIcon className={ styles.buttonIcon } />
				<FormattedMessage { ...messages.back } />
			</Button> }
			<Button onClick={ goToNextStep } data-testid={ "next-step-button" }>
				{
					( isBrandInsightsStep && otherProductsToSetUp )
						? <FormattedMessage { ...messages.BrandInsightsContinueButton } />
						: <FormattedMessage { ...messages.continueButton } />
				}
				<ArrowLongRightIcon className={ styles.buttonIcon } />
			</Button>
		</ButtonsContainer>
		<SkipInstallationFlowLink />
	</>;
};
